import React from 'react';
import { Avatar } from 'barte-design-system';
import { Comment } from './types';
import { initials, timeAgo } from './util';

interface Props {
  comment: Comment;
  canDelete: boolean;
  onDelete: (id: string) => void;
}

export function CommentItem({ comment, canDelete, onDelete }: Props) {
  return (
    <div className="bc-comment">
      <Avatar variant="text" size="sm" initials={initials(comment.author_name)} />
      <div className="bc-comment__main">
        <div className="bc-comment__meta">
          <span className="bc-comment__author">{comment.author_name}</span>
          <span className="bc-comment__time">{timeAgo(comment.created_at)}</span>
        </div>
        <div className="bc-comment__text">{comment.body}</div>
        {canDelete && (
          <div className="bc-comment__actions">
            <button
              type="button"
              className="bc-linkbtn bc-linkbtn--danger"
              onClick={() => onDelete(comment.id)}
            >
              Excluir
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
